import { api } from "@/lib/api";

// Offline queue for form submissions that need a connection (web check-ins,
// payment proofs). When submitted offline, the request is kept on this device
// and auto-posted to its endpoint once the browser is back online — the same
// resilience the Make Booking drafts already have.
const KEY = "ws_offline_forms";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};
const write = (arr) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(arr));
  } catch {
    /* storage unavailable — queue lives only for this session */
  }
  if (typeof window !== "undefined") window.dispatchEvent(new Event("offline-forms-changed"));
};

export const listForms = (kind) => (kind ? read().filter((f) => f.kind === kind) : read());
export const formCount = (kind) => listForms(kind).length;

// kind: "checkin" | "payment" — endpoint is the API path to POST to on sync.
export const queueForm = (kind, endpoint, payload) => {
  const arr = read();
  const f = {
    id: `f_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    kind,
    endpoint,
    payload,
    createdAt: new Date().toISOString(),
  };
  arr.push(f);
  write(arr);
  return f;
};

export const removeForm = (id) => write(read().filter((f) => f.id !== id));

let syncing = false;
export const syncForms = async (kind) => {
  if (syncing || !navigator.onLine) return { sent: 0, dropped: 0 };
  const arr = kind ? read().filter((f) => f.kind === kind) : read();
  if (!arr.length) return { sent: 0, dropped: 0 };
  syncing = true;
  let sent = 0;
  let dropped = 0;
  try {
    for (const f of arr) {
      try {
        await api.post(f.endpoint, f.payload);
        removeForm(f.id);
        sent++;
      } catch (e) {
        const st = e?.response?.status;
        // Hard validation rejections (4xx, not the synthetic offline 0) — drop so the
        // queue never gets stuck forever. Network / 5xx — stop and retry on next event.
        if (st && st >= 400 && st < 500) {
          removeForm(f.id);
          dropped++;
        } else {
          break;
        }
      }
    }
  } finally {
    syncing = false;
  }
  return { sent, dropped };
};
